import React, {useState, useEffect, useContext} from 'react'
import Table from '../../uicomponents/table/Table'
import { BackArrow, TrashIcon, TeammanagementFallback, MarkPresentWithExceptionIcon} from "../../assets/images/index"
import { TeamManagementContext } from "./teammanagementContext"
import styles from "../../assets/stylesheets/pages/teammanagement/teamlead.module.scss"
import moment from "moment";
import { getAttendanceStats, markAttendanceWithException } from './service'
import capitalise from "../../helper/Capitalise";
import useApi from "../../hooks/useApi";
import Datepicker from '../../uicomponents/date-picker'
import Popup from '../../uicomponents/popup'
import Dropdown from 'react-dropdown';
import FutworkButton from '../../uicomponents/button'
import checkIsEmpty from '../../helper/checkIsEmpty'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import CustomTab from '../../components/utilities/CustomTab'

const reasonForException = [
    {label: 'Attendance criteria outdated', value: 'attendance_criteria_outdated'},
    {label: `Team lead's discretion`, value: 'tl_discretion'},
    {label: 'Data Flow', value: 'data_flow'},
    {label: 'Futwork Downtime', value: 'fw_downtime'},
    {label: 'Futwork Operations', value: 'fw_op'}
]

const ATTENDANCE_TABS = [
    {
        label: 'Complete',
        value: 'complete'
    },
    {
        label: 'Incomplete',
        value: 'incomplete'
    },
]

const Attendance = () => {
    const { setAgentListView, teamSelected, setTeamSelected, isMarkException, setMarkException,
        agentsSelectedForMarking, setAgentsSelectedForMarking,
        isDateRangeExceeded, setIsDateRangeExceeded,
        selectedDate, setSelectedDate
     } = useContext(TeamManagementContext)
    const getAttendanceStatsApi = useApi(getAttendanceStats)
    const [currentPageForComplete, setCurrentPageForComplete] = useState(1)
    const [currentPageForInComplete, setCurrentPageForInComplete] = useState(1)
    const [limit, setLimit] = useState(10)
    const [search, setSearch] = useState('')
    const [reasonSelected, setReasonSelected] = useState("")
    const [apiMsg, setApiMsg] = useState({
        type: '',
        msg: ''
    })
    const [attendanceFilter, setAttendanceFilter] = useState({
        label: ATTENDANCE_TABS[0].label, value: ATTENDANCE_TABS[0].value
    })
    const [completedAttendance, setCompletedAttendance] = useState([])
    const [incompleteAttendance, setIncompleteAttendance] = useState([])

    useEffect(() => {
    //     const {agent} = teamSelected || {}
        const payload = {
            "startDate": moment().format("YYYY-MM-DD"),
            "endDate":  moment().format("YYYY-MM-DD"),
            "teamLeadId": teamSelected && teamSelected.id ? teamSelected.id : '',
        }
        getAttendanceStatsApi.request(payload)
        // setAttendanceFilter('all')
    }, [])


    const closeException = () => {
        setReasonSelected('')
        setMarkException(false)
        setApiMsg({
            type: '',
            msg: ''
        })
        const {agent} = teamSelected || {}
        const payload = {
            "startDate": selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
            "endDate":  selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
            "teamLeadId": teamSelected && teamSelected.id ? teamSelected.id : ''
        }   
        getAttendanceStatsApi.request(payload)
    }

    const renderMarkWithException = () => {
        // const {agent:{name}} = teamSelected || {}
        return <Popup
        show={isMarkException}
        closePopup={() => closeException()}
        size='sm'
        heading={`Mark Present with Exception`}
        >
            <div className={styles.reason_wrapper}>
            <b>Reason</b>
            <Dropdown
            options={reasonForException}
            onChange={(e) => {
                setReasonSelected(e.label)
                // if(!inputAdded)setInputAdded(true)
                // setCriteriaParameterSelected({
                //     ...criteriaParameterSelected,
                //     parameter: e.value
                // })
            }}
            placeholder="Select reason"
            className={styles['paramter_dropdown']}
            // value={criteraParameter.find(({ value }) => criteriaParameterSelected.parameter == value) ? criteriaParameterSelected.parameter : ''}
            />
            </div>
            
        <div>
            <div>{agentsSelectedForMarking && agentsSelectedForMarking.length} agent(s) selected</div>
        </div>
        <div style={{display: 'flex', justifyContent: 'flex-end', gap: '2rem', margin: '2rem 0'}}>
            {
            !checkIsEmpty(apiMsg) ?
                <div className={apiMsg.type == 'success' ?
                    styles['success-msg'] : styles['error-msg']}>{apiMsg.msg}</div>
                : null
            }
            {
                apiMsg.type == 'success' ? null :
                <div style={{display: 'flex', gap: '1rem'}}>
                    <FutworkButton buttonStyle="primary--outline non-rounded" buttonSize="sm" onClick={() => closeException()}>Cancel</FutworkButton>
                    <FutworkButton buttonStyle="navy--solid non-rounded" buttonSize="sm" disabled={reasonSelected ? false : true} onClick={() => markAttendance()}>Submit</FutworkButton>
                </div>
            }
        </div>
        </Popup>
    }


    const markAttendance = async () => {
        // {
        //     "attendanceIds": ["string"], // Required - array of attendance IDs
        //     "exceptionReason": "string"  // Required - reason for marking as present
        //   }
    
        const attendanceIds = agentsSelectedForMarking && agentsSelectedForMarking.map(({attendanceId}) => attendanceId)
        const payload = {
            "attendanceIds": attendanceIds,
            "exceptionReason": reasonSelected
        }

        // setTimeout(() => {
        //     setApiMsg({
        //         type: 'success',
        //         msg: `Attendance marked successfully`
        //     })
        // }, 5000);

        // return false

        try {
            const result = await markAttendanceWithException(payload)
            if(result.status == 200){
                setApiMsg({
                    type: 'success',
                    msg: result && result.data && result.data.msg ? 
                    result.data.msg : `Attendance criteria updated successfully`
                })
            }
        } catch (error) {
            console.error(error.response)
            setApiMsg({
                type: 'error',
                msg: `Something went wrong`
            })
        }
    }

    const handlePopups = () => {
        if(isMarkException) return renderMarkWithException()
        else return null
    }

    const getFilteredData = (data) => { 
        const completedStatuses = ['Complete', 'Complete with exception']
        const incompleteStatuses = ['Incomplete']
        if (!data || data.length <= 0) {
            return {
                completedAttendance: [],
                incompleteAttendance: []
            }
        }
        const completedAttendance = data.filter(item => {
            const status = formatAttendanceStatus(item)
            if(completedStatuses.includes(status)) {
                return item
            }
        })

        const incompleteAttendance = data.filter(item => {
            const status = formatAttendanceStatus(item)
            if(incompleteStatuses.includes(status)) {
                return item
            }
        })

        return {
            completedAttendance,
            incompleteAttendance
        }
    }

    const formatAttendanceCriteria = (attendanceCriteria) => {
        const lookupObj = {
            "connectedAttempts": 'Connected Attempts (count)',
            "spokenMin": 'Spoken Minutes (in minutes)',
            "productiveTime": 'Working Time (in seconds)',
            "(connectedAttempts + notConnectedAttempts)": 'Call Attempts (count)'
        }
        const splitArray = attendanceCriteria.split('>=')
        const [first, last] = splitArray
        const formattedParameter = lookupObj[first.trim()]
        return formattedParameter ? `${formattedParameter} is greater than or equal to ${last.trim()}` : 'NA'
    }
    const columns = [
        {
            Header: 'Name',
            accessor: "name",
            disableSortBy: true
        },
        {
            Header: 'Mobile',
            accessor: "mobile",
            disableSortBy: true
        },
        {
            id: 'dailyTarget',
            Header: "Daily Target",
            accessor: "dailyTarget",
            Cell: ({cell}) => (<div className={styleStatusAttendance(cell.row.original.attendance)}>{formatAttendanceStatus(cell.row.original)}</div>),
            disableSortBy: true
        },
        {
            id: 'callsAttempted',
            Header: 'Calls Attempted',
            accessor: (row) => Number(row.connectedAttempts) + Number(row.notConnectedAttempts),
            Cell: ({cell}) => (<div>{Number(cell.row.original.connectedAttempts)+
                Number(cell.row.original.notConnectedAttempts)}</div>),
        },
        {
            Header: 'Calls Connected',
            accessor: "connectedAttempts",
            disableSortBy: true
        },
        {
            Header: 'Working Time',
            accessor: "productiveTime",
            Cell: ({value}) => ( value ? getTimeFormat(value) : 0),
            disableSortBy: true
        },
        {
            Header: 'Minutes Spoken',
            accessor: "spokenMin",
            disableSortBy: true
        },
        {
            Header: 'Attendance Criteria',
            accessor: "attendanceCriteria",
            width: "20%",
            Cell: ({value}) => {
                return value ? formatAttendanceCriteria(value) : 'NA'
            },
            disableSortBy: true
        },
        {
            id: 'view',
            Header: 'Actions',
            width: "2%",
            Cell: (cell) => {
                return (<div className={styles['action-mark-with-exception']}>
                    <img src={MarkPresentWithExceptionIcon} onClick={() => {
                        if(moment(moment().format("YYYY-MM-DD")).isSame(selectedDate) || isDateRangeExceeded === true || cell.row.original.attendance == 'present') return
                        setAgentsSelectedForMarking([{...cell.row.original}])
                        setMarkException(true)
                        // setTeamSelected({
                        //     ...teamSelected,
                        //     agent: {...cell.row.original}
                        // })
                        // setShowAttendanceCriteria(true)
                    }} className={moment(moment().format("YYYY-MM-DD")).isSame(selectedDate) || isDateRangeExceeded === true || cell.row.original.attendance == 'present' ? styles['disable_button'] : ''}/>
                </div>) 
            },
            disableSortBy: true
        }
 
    ]

    const formatAttendanceStatus = ({attendance, exception}) => {
        return capitalise(exception && exception.reason ? 'Complete with exception' : 
            // TODO: check for the attendance value
            (!attendance || attendance == null || attendance == '' || attendance == 
                'absent'
            ) ? 'Incomplete' : 'Complete')
    }

    const styleStatus = (status) => {
        switch (status) {
            case 'looking_to_work':
                return `${styles.caller_status_styling} ${styles.idle}`
            case 'working':
                return `${styles.caller_status_styling} ${styles.active}`
            case 'ban':
                return `${styles.caller_status_styling} ${styles.ban}`
            case 'not_looking_to_work':
                return `${styles.caller_status_styling} ${styles.not_looking_to_work}`
            case 'on_a_break':
                return `${styles.caller_status_styling} ${styles.on_a_break}`
            default:
                return `${styles.caller_status_styling} ${styles.not_looking_to_work}`
        }
    }

    const styleStatusAttendance = (attendance = 'absent') => {
        return attendance.toLowerCase() == 'absent' ? `${styles.caller_status_styling} ${styles.idle}`
        : `${styles.caller_status_styling} ${styles.active}`
    }


    const getTimeFormat = (value) => {
        let totalSeconds = value
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        // If you want strings with leading zeroes:
        minutes = String(minutes).padStart(2, "0");
        hours = String(hours).padStart(2, "0");
        seconds = String(seconds).padStart(2, "0");

        // return moment(seconds*1000).format('HH:mm:ss')
        return `${hours}h ${minutes}m  ${seconds}s`
    }

    const fetchAttendance = (payload) => {
        getAttendanceStatsApi.request(payload)
    }

    const Calendar = () => {
        return <Datepicker
        placeholderText="Click to select a date"
        selectedDate={moment(selectedDate).toDate()}
        isDateRange = {false}
        maxDate={moment().toDate()}
        // from={moment().toDate()}
        // to={moment(defaultDate.to).toDate()}
        onChange={(date) => {
            // const [from, to] = daterange
            setSelectedDate(moment(date).format("YYYY-MM-DD"))
            const payload = {
                "startDate": moment(date).format("YYYY-MM-DD"),
                "endDate":  moment(date).format("YYYY-MM-DD"),
                "teamLeadId": teamSelected && teamSelected.id ? teamSelected.id : ''
            }

            fetchAttendance(payload)

            if(moment(date).isAfter(moment().subtract(7, 'days'))){
                setIsDateRangeExceeded(false)
            }else{
                setIsDateRangeExceeded(true)
            }
        }}
    />
    }

    const {data} = getAttendanceStatsApi && getAttendanceStatsApi.data || {}
    const {loading, error} = getAttendanceStatsApi
    const {data: stats, total} = data || {}

    useEffect(() => {
        if(!loading){
            const { completedAttendance, incompleteAttendance } = getFilteredData(stats)
            setCompletedAttendance(completedAttendance)
            setIncompleteAttendance(incompleteAttendance)
        }   
    },[data, loading])

    const updateSelection = (rows = []) => {
        setAgentsSelectedForMarking(rows && rows.filter(row => row.attendance != 'present'))
    }
    
    const insertId = (data) => {
        return data.map((item, idx) => {
            return {
                id: `${idx+1}`,
                ...item
            }
        })
    }

    const checkIfAlreadyPresent = (attendanceData) => {
        attendanceData && attendanceData.map((item, idx) => {
            if(item.attendance == 'present' || isDateRangeExceeded === true) {
                item.isDisabled = true
            }
            return item
        })
        return attendanceData
    }

    const isRowDisablingConditionMet = (row) => {
        // return row && row.values && row.values.attendance === 'present';
        return row && row.values && row.values.attendance === 'present' || isDateRangeExceeded === true;
    };

    return(
        <div>
            <div className={styles.attendance_date_row}>
                <CustomTab 
                tabs={ATTENDANCE_TABS} 
                setActiveTabFn={(data) => {
                    setAttendanceFilter({label: data.label, value: data.value})
                }} 
                />
                <div style={{minWidth: '20%', textAlign: 'right'}}>
                    <Calendar/>
                </div>
            </div>
             {error && <p>{typeof error == 'object' && 
            error !== null &&
            !Array.isArray(error)
            ? error.error || error.msg : error}</p>}
            
            
            <Table
                columns={columns}
                data={attendanceFilter.value == "complete" ?
                    checkIfAlreadyPresent(completedAttendance) || [] :
                    checkIfAlreadyPresent(incompleteAttendance) || []
                }
                totalCount={attendanceFilter.value == "complete" ?
                    completedAttendance.length : incompleteAttendance.length
                }
                limit={limit}
                currentPage={
                    attendanceFilter.value == "complete" ? 
                    currentPageForComplete : currentPageForInComplete
                }
                setCurrentPage={
                    attendanceFilter.value == "complete" ? 
                    setCurrentPageForComplete : setCurrentPageForInComplete
                }
                loading={loading}
                type='client'
                // sortChange={sortChange}
                searchBy='name / mobile / email / status'
                isGlobalFilter={true}
                selectType='multi'
                manualSortBy = {false}
                selectRow = {true}
                updateRowSelect={updateSelection}
                isCheckBoxHeaderDisabled = {
                    isRowDisablingConditionMet
                }
            />
            {handlePopups()}
        </div>
    )
}

export default React.memo(Attendance)